/* eslint-disable */
import 'babel-polyfill'
import '@/common/compatUtil'
import vueLogger from '@/common/logger'
import uweb from '@/plugins/uweb'
import { isDev, statUrl, statSiteId, cnzzSiteId } from '@/common/env'
import {
  checkActivateUrl,
  redirectMainUrl,
  getUrlParams,
  redirectTokenUrl,
} from '@/common/miscutil'
import LoadingBar from 'jsapp/widgets/loadingBar'

// 引入 components 控件
import Omui from 'omui/components/index.js'
// 引入具体的控件样式
import '@/style/components.less' // 会包含 csscom 中的 rest.less site.less variable.less mixin.less

import ApiUtil from '@/apis/apiutil'
import wxWrapper from '@/wxapi/WxWrapper'
import RpcApiWrapper from '@/apis/rpcApiWrapper'
import BaseOPStatusUtil from 'baseapp/store/baseOPStatusUtil'
import Vue from 'vue'
// 不要删除下面这个reigster import，其中会自动导入 omui/combines 中的控件
// import omuiCombinesRegister from '../../plugins/omui/combines/register'

window.Vue = Vue
// 注册Omui
Vue.use(Omui)
// 注册Logger插件
Vue.use(vueLogger, {dev: isDev})
// 注册LoadingBar
Vue.component('loading-bar', LoadingBar)
// 注册友盟统计插件
Vue.use(uweb, {
  debug: isDev,
  'cnzz': {
    'siteId': cnzzSiteId
  },
  'stat': {
    'src': statUrl,
    'siteId': statSiteId,
  },
  'autoPageview': false
})
let params = getUrlParams(window.location.href)
if (params.c) {
  uweb.setCustomVar('c', params.c, '-1')
}
Vue.config.productionTip = false

import {arrUtil } from "jscom/utils/arrutil"
import {mapUtil } from "jscom/utils/maputil"
import {objUtil } from "jscom/utils/objutil"
import {strUtil } from "jscom/utils/strutil"
import {dtUtil, sysUtil } from "jscom/utils/sysutil"
import {designUtil } from 'jscom/utils/designutil'
import {VueUtil } from 'jscom/utils/vueutil'

function addUtil(key, instance) {
  window.Vue.prototype[key] = instance
  window.Vue[key] = instance
  window[key] = instance
}

function processApiError (error, defaultMsg) {
  Vue.$log.error(error)
  let msg = defaultMsg
  if (sysUtil.isStringObject(error.msg)) {
    msg = error.msg
  }
  Vue.prototype.$toast.fail(msg)
}

export default function init (store, router, initMutationType) {
  store.state.$uweb = uweb
  // 注册ApiUtil
  ApiUtil.install(store)
  // 注册rpcApiWrapper
  RpcApiWrapper.install(store)
  //
  BaseOPStatusUtil.install(store)

  // 注册 Utils
  window.Vue.prototype.$strUtil = strUtil
  window.Vue.$strUtil = strUtil
  window.$strUtil = strUtil

  window.Vue.prototype.$objUtil = objUtil
  window.Vue.$objUtil = objUtil
  window.$objUtil = objUtil

  window.Vue.prototype.$arrUtil = arrUtil
  window.Vue.$arrUtil = arrUtil
  window.$arrUtil = arrUtil

  window.Vue.prototype.$mapUtil = mapUtil
  window.Vue.$mapUtil = mapUtil
  window.$mapUtil = mapUtil

  window.Vue.prototype.$dtUtil = dtUtil
  window.Vue.$dtUtil = dtUtil
  window.$dtUtil = dtUtil


  window.Vue.prototype.$designUtil = designUtil
  window.Vue.$designtUtil = designUtil
  window.$desingUtil = designUtil

  window.Vue.prototype.$processApiError = processApiError
  window.Vue.$processApiError = processApiError
  window.$processApiError = processApiError

  addUtil('$vueUtil', new VueUtil(router, store))

  //
  router.beforeEach((to, from, next) => {
    // if (window.endLoading) {
    //   window.endLoading()
    // }
    LoadingBar.start()
    if (wxWrapper.checkWxAuthorise(window.location.href, store, true)) {
      console.warn('beforeEach checkWxAuthorise from: ' + from.path + ' to:' + to.path)
      return
    }
    if (redirectMainUrl(to, from, next, store.getters.isLogin, uweb)) {
      console.warn('beforeEach redirectMainUrl from: ' + from.path + ' to:' + to.path)
      return
    }
    redirectTokenUrl()
    if (to.matched.some(route => route.meta.requiresAuth)) {
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      if (!store.getters.isLogin) {
        console.warn('beforeEach isNotLogin from: ' + from.path + ' to:' + to.path)
        let redirectParams = {
          path: '/login',
          query: {'redirect': to.fullPath}
        }
        next(redirectParams)
      } else {
        next()
      }
    } else {
      next() // 确保一定要调用 next()
    }
  })

  router.afterEach((to, from) => {
    LoadingBar.finish()
    var referrer
    if (to.query.referrer) {
      referrer = to.query.referrer
    } else if (from.fullpath === '/') {
      referrer = document.referrer
    } else {
      referrer = from.fullPath
    }
    uweb.trackPageview(to.fullPath, referrer)
  })

  // 从链接中获取 sellerCompanyid 并设置到 store 中
  if (params.sellerCompanyid) {
    store.state.sellerCompanyid = parseInt(params.sellerCompanyid)
  }
  store.commit(initMutationType)
  checkActivateUrl(window.location)
  wxWrapper.checkWxAuthorise(window.location.href, store)
  wxWrapper.config()
}



// WEBPACK FOOTER //
// ./src/apps/baseapp/baseMain.js